/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Merge_UpInputs */



/**
* | output |
* | --- |
* | "Merge Up" |
*
* @param {Shortcut_Keys_Name_Merge_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_merge_up = /** @type {((inputs?: Shortcut_Keys_Name_Merge_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Merge_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner vers le haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar hacia arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マージアップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊपर विलय करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fusão")
	return /** @type {LocalizedString} */ ("Merge Up")
});